import React from 'react';
import { ApplicationDetails } from 'components/ApplicationDetails';

export const Application = () => {
  return (
    <div>
      <div>{<ApplicationDetails />}</div>
    </div>
  );
};
